<!--
 * File: cc-grid-selector.component.html                                       *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 4th May 2022 15:43:50                              *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 09:58:13                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 -->

<div class="flex flex-row justify-content-center max-w-max m-0">
  <p-button
    size="small"
    [icon]="lockIcon"
    (click)="toggle()"
    [severity]="'info'"
    [styleClass]="'n-button-icon'"
    [text]="true"
  >
  </p-button>

  <p-button
    size="small"
    (click)="confirmRemovePage($event, pageId)"
    [disabled]="!lock"
    [icon]="cancelIcon"
    [severity]="'danger'"
    *ngIf="lock"
    [styleClass]="'n-button-icon'"
    [text]="true"
  >
  </p-button>

  <p-button
    size="small"
    (click)="menuGridSelection.toggle($event)"
    [icon]="'fa fa-ellipsis-vertical'"
    *ngIf="!lock"
    [styleClass]="'n-button-icon'"
    [text]="true"
  >
  </p-button>

  <p-menu
    #menuGridSelection
    [model]="gridTemplateItems"
    [popup]="true"
  ></p-menu>
  <!-- <p-dropdown
    [options]="grids"
    [(ngModel)]="selectedGrid"
    optionLabel="name"
    [disabled]="lock"
    (onChange)="changeFormat($event)"
    [styleClass]="'my-grid-selector'"
    *ngIf="!lock"
  ></p-dropdown> -->
</div>
